module.exports = __webpack_public_path__ + "static/media/50.e8b7a70a.jpg";